import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { PremiumPreviewData } from '../store/schema/PremiumPreviewData';
import { getTextStringSkittle } from '../utils/getTextStringSkittle';
import loc from 'owa-localize';

const styles = require('./UpsellSkittle.scss');

export interface UpsellSkittleCalloutBasicTextActivatedProps {
    premiumPreviewData: PremiumPreviewData;
}

const UpsellSkittleCalloutBasicTextActivated = observer(function UpsellSkittleCalloutText(
    props: UpsellSkittleCalloutBasicTextActivatedProps
) {
    const { premiumPreviewData } = props;
    const { stringToShowInSkittle, numberToShow } = getTextStringSkittle(
        premiumPreviewData,
        null /*numberOfDays */,
        null /* numberOfSuggestions*/
    );
    return (
        <div className={styles.skittleCalloutTextContainer}>
            <span className={styles.premimumFlagsFound}>{numberToShow}</span>
            <span className={styles.premimumpreviewDaysText}>{loc(stringToShowInSkittle)}</span>
        </div>
    );
});

export { UpsellSkittleCalloutBasicTextActivated };
